import React from 'react'

import ArchiveIcon from 'Assets/Images/icons/archive'

export const ButtonArchiveInlineUnstyled = props => (
  <div
    className={props.className}
    onClick={props.onClickHandler}
    title={props.title}
  >
    <ArchiveIcon />
    {props.label}
  </div>
)
